<script lang="ts">
  import { page } from '$app/stores';
  import { TextCopy, TextInfo } from '$lib/components/text';
  import { AppPath } from '$lib/features/app';
  import type { SimplesSimeiDto } from '$lib/features/bff/sdk';
  import { formatDate } from '$lib/features/format';

  /** Required */
  export let simei: SimplesSimeiDto;
  /** Required */
  export let simples: SimplesSimeiDto;
  /** Required */
  export let updated: string;

  $: isUpdatable = $page.url.pathname?.startsWith(AppPath.OFFICE);
  $: updateMessage = isUpdatable ? ', clique no ícone de atualizar para obtê-lo.' : '.';
</script>

{#if updated}
  <div class="flex flex-wrap gap-x-8 gap-y-6">
    <!-- Simples Nacional -->
    <TextInfo icon="calculator" label="Simples Nacional">
      {#if simples?.optant}
        <TextCopy value="Optante" />
        <span>- Desde</span>
        <TextCopy value={formatDate(simples.since)} />
      {:else}
        <TextCopy value="Não Optante" />
      {/if}
    </TextInfo>

    <!-- MEI -->
    <TextInfo icon="square-user-round" label="MEI">
      {#if simei?.optant}
        <TextCopy value="Enquadrado" />
        <span>- Desde</span>
        <TextCopy value={formatDate(simei.since)} />
      {:else}
        <TextCopy value="Não Enquadrado" />
      {/if}
    </TextInfo>
  </div>
{:else}
  <p class="text-surface-600-300-token text-sm">
    O regime tributário ainda não está disponível em nossa plataforma{updateMessage}
  </p>
{/if}
